import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { EmployeeReportingToService } from '../../../Model/ReportingToService/employee-reporting-to.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-site-head',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './site-head.component.html',
  styleUrl: './site-head.component.scss'
})
export class SiteHeadComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  UserLoad: any[] = [];
  SiteId: any = null;
  SiteName: string = '';
  SiteCode: string = '';
  SiteLoad : any[] = [];
  SiteDataLoad : any[] = [];
  BranchMaster : any[] = [];
  ClientLoad: any[] = [];
  BranchId: any = null;
  BranchName: string = '';
  ClientId: any = null;
  ClientName: string = '';
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private EmployeeService: EmployeeReportingToService,
    protected common:CommonService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('GetEssUserMaster');
    this.ComboLoad('Branch');
  }
  
  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = null;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,

    }).subscribe({
      next: (response) => {
        console.log('API Response', response);
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        }
        else if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }

  Search() {
    if (!this.BranchName || this.BranchName == '' || this.BranchId == 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    const ReportingToData = {
      SelectType: 'ReportingToSite',
      BranchID: this.BranchId,
      ClientID:  this.ClientId,
      SiteID:  this.SiteId,
    }
    this.EmployeeService.EmployeeReportingToSelect(ReportingToData).subscribe(
      data => {
        if (data.Table && data.Table.length > 0) {
          this.SiteDataLoad = Object.values(data.Table);
        } else {
          this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
        }
        //this.ReportingToData = Object.values(data.Table);
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false
      }
    );
  }
  
  async save(){
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        if(this.common.PageRight.IsEdit){
          this.Update();
        }
      }
    }).catch(() => {

    });
  }
  Update() {
    if (this.SiteDataLoad.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    this.User = this.sessionService.GetUserDetails();
    const Data = this.SiteDataLoad.map(rt => {
      return {
        SiteID: rt.SiteMasterID,
        SiteOwnerID: rt.SiteOwnerID,
      };
    });
    const ReportData = {
      SelectType: 'Update',
      ESS_ReportingToSite: Data,
      UserId: this.User.UserId
    }
    this.isDisabled = true;
    this.EmployeeService.ReportingToSite(ReportData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.SiteDataLoad = [];
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
        this.Search();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  
  clear(){
    this.SiteDataLoad = [];
  }
}
